export const vehicleMap = {
  0: {
    type: 'Cavalo',
    key: 'primaryVehicle',
  },
  1: {
    type: 'Sub-reboque 1',
    key: 'secondaryVehicle1',
  },
  2: {
    type: 'Sub-reboque 2',
    key: 'secondaryVehicle2',
  },
  3: {
    type: 'Sub-reboque 3',
    key: 'secondaryVehicle3',
  },
  4: {
    type: 'Sub-reboque 4',
    key: 'secondaryVehicle4',
  },
  5: {
    type: 'Sub-reboque 5',
    key: 'secondaryVehicle5',
  },
}

export const trackingDeviceTechnology = [
  'AUTOTRAC',
  'CONTROLSAT',
  'OMNILINK',
  'ONIXSAT',
  'RODOSIS',
  'AUTOCARGO',
  'CONTROLLOC',
  'TRANSPONDER',
  'SASCAR',
  'CIELO',
  'ALFATEST',
  'CARRIERWEB',
  'AUTOTRAC CELULAR',
  'AUTOSAT',
  'CHIPSAT',
  'CRONOS',
  'SIGHRA',
  'PÓSITRON',
  'TALTO',
  'CERTASAT',
  'WEBTRAC',
  'VIGITRACK',
  'VELTEC',
  'COMMANDERSAT',
  'CAMARGOSAT',
  'SIMTRACK',
  'CARGO TRACCK',
  '3S',
  'TRACSYSTEM',
  'LINKER',
  'SITRACK',
  'CEABS',
  'TRACKER',
  'BRASILTRACK',
  'APISULMOB',
  'RASTRO',
  'POINT TRACK',
  'GSSAT',
  'IBOR',
  'WORLD SAT',
  'FORT RASTREAMENTO',
  'KMM',
  'CREARE',
  'TRAC GOLD',
  'T4S',
  'POLITRACKER',
  'WR SAT',
  'AUTOVISION',
  'MILLENNIUM',
  'RSAT',
  'SIGA +',
  'TEC SZ LORA',
  'RAVEX',
  'TBV',
  'BLOCKSAT',
  'AUTOTRAC ADE+',
]

export const trackingDeviceTechnologyWithId = trackingDeviceTechnology.map((item, i) => ({
  id: i,
  value: item,
}))

export const vehicles = [
  {
    label: 'VLC',
    value: 'VLC',
    icon: 'vlc.svg',
    cars: 1,
    category: 'LEVE',
  },
  {
    label: '3/4',
    value: 'TRES_QUARTO',
    icon: '3-4.svg',
    cars: 1,
    category: 'LEVE',
  },
  {
    label: 'Toco',
    value: 'TOCO',
    icon: 'toco.svg',
    cars: 1,
    category: 'LEVE',
  },
  {
    label: 'Truck',
    value: 'TRUCK',
    icon: 'truck.svg',
    cars: 1,
    category: 'MEDIO',
  },
  {
    label: 'Bitruck',
    value: 'BITRUCK',
    icon: 'truck.svg',
    cars: 1,
    category: 'MEDIO',
  },
  {
    label: 'Carreta',
    value: 'CARRETA',
    icon: 'carreta.svg',
    cars: 2,
    category: 'PESADO',
  },
  {
    label: 'Carreta LS',
    value: 'CARRETA_LS',
    icon: 'carreta.svg',
    cars: 2,
    category: 'PESADO',
  },
  {
    label: 'Vanderleia',
    value: 'CARRETA_VANDERLEIA',
    icon: 'carreta.svg',
    cars: 2,
    category: 'PESADO',
  },
  {
    label: 'Bitrem',
    value: 'BITREM',
    icon: 'bitrem.svg',
    cars: 3,
    category: 'PESADO',
  },
  {
    label: 'Rodotrem',
    value: 'RODOTREM',
    icon: 'treminhao.svg',
    cars: 4,
    category: 'PESADO',
  },
]

export const bodyworks = [
  {
    label: 'Sider',
    value: 'SIDER',
    icon: 'sider.svg',
    category: 'FECHADA',
  },
  {
    label: 'Baú',
    value: 'BAU',
    icon: 'bau.svg',
    category: 'FECHADA',
  },
  {
    label: 'Baú Frigorífico',
    value: 'BAU_FRIGORIFICO',
    icon: 'bau frigorifico.svg',
    category: 'FECHADA',
  },
  {
    label: 'Refrigerado',
    value: 'REFRIGERADO',
    icon: 'refrigerado.svg',
    category: 'FECHADA',
  },
  {
    label: 'Grade Baixa',
    value: 'GRADE_BAIXA',
    icon: 'grade baixa.svg',
    category: 'ABERTA',
  },
  {
    label: 'Caçamba',
    value: 'CACAMBA',
    icon: 'cacamba.svg',
    category: 'ABERTA',
  },
  {
    label: 'Graneleiro',
    value: 'GRANELEIRO',
    icon: 'graneleiro.svg',
    category: 'ABERTA',
  },
  {
    label: 'Baú Container',
    value: 'BUG_PORTA_CONTAINER',
    icon: 'bauc.svg',
    category: 'ESPECIAL',
  },
  {
    label: 'Cegonheiro',
    value: 'CEGONHEIRO',
    icon: 'cegonheiro.svg',
    category: 'ESPECIAL',
  },
  {
    label: 'Gaiola',
    value: 'GAIOLA',
    icon: 'gaiola.svg',
    category: 'ESPECIAL',
  },
  {
    label: 'Munck',
    value: 'MUNCK',
    icon: 'munck.svg',
    category: 'ESPECIAL',
  },
  {
    label: 'Prancha',
    value: 'PRANCHA',
    icon: 'prancha.svg',
    category: 'ESPECIAL',
  },
  {
    label: 'Silo',
    value: 'SILO',
    icon: 'silo.svg',
    category: 'ESPECIAL',
  },
  {
    label: 'Tanque',
    value: 'TANQUE',
    icon: 'tanque.svg',
    category: 'ESPECIAL',
  },
]

export const fleetTypes = [
  {
    label: 'Frota Própria',
    value: 'own',
    icon: 'bau.svg',
  },
  {
    label: 'Frota Terceira',
    value: 'third',
    icon: 'third truck.svg',
  },
]
